import { format, isToday, isTomorrow } from 'date-fns'
import { ja } from 'date-fns/locale'

export const getDateText = (date: Date): string => {
  if (isToday(date)) {
    return '本日'
  } else if (isTomorrow(date)) {
    return '明日'
  } else {
    return format(date, 'M月d日（E）', { locale: ja })
  }
}

export const getTimeText = (date: Date): string => {
  return format(date, 'H 時 m 分').replace(' 0 分', '')
}
